import gql from 'graphql-tag';
import { clients } from '../../../util/clients';

const { backend, backendRest } = clients.direct;
export const urlEncodeObject = (obj) => new URLSearchParams(obj).toString();

export const taxPaymentTransactionActions = {
  async generateNextPaymentNumber({ commit, dispatch },
    { fiscalYear }) {
    let results;
    try {
      await dispatch('reAuth', null, { root: true });
      results = await backend.query({
        query: gql`query taxMaxPaymentId ($criteria: taxPaymentIdCriteriaType) {
          taxMaxPaymentId (criteria: $criteria) { max }
        }`,
        variables: {
          criteria: { fiscalYear },
        },
        fetchPolicy: 'no-cache',
      });
      clients.handleGQLErrors(results, commit);
      const { taxMaxPaymentId } = results.data;
      commit('setStats', taxMaxPaymentId);
      if (taxMaxPaymentId.max === null) dispatch('flashError', 'There was a problem getting the last payment number.', { root: true });
    } catch (e) {
      dispatch('logException', e, { root: true }); clients.handleGQLErrors(results, commit);
      dispatch('flashError', 'There was a problem determining the last payment id.', { root: true });
    }
  },
  async callMakeGLobalPaymentNumberUndefined({ commit, dispatch }) {
    let results;
    try {
      await dispatch('reAuth', null, { root: true });
      results = await backend.query({
        query: gql`query makeGLobalPaymentIdUndefined ($criteria: taxStatsCriteriaType) {
          makeGLobalPaymentIdUndefined (criteria: $criteria) { max }
        }`,
        variables: {
          criteria: {},
        },
        fetchPolicy: 'no-cache',
      });
      clients.handleGQLErrors(results, commit);
    } catch (e) {
      dispatch('logException', e, { root: true }); clients.handleGQLErrors(results, commit);
      dispatch('flashError', 'There was a problem getting the  global payment variable.', { root: true });
    }
  },
  async generateMultipleReceipt({ commit, dispatch },
    { fiscalYear, taxYear }) {
    let results;
    try {
      await dispatch('reAuth', null, { root: true });
      results = await backend.query({
        query: gql`query taxMaxRecieptNumbers ($criteria: multipleMaxRecieptNumberInput) {
          taxMaxRecieptNumbers (criteria: $criteria) { maxReceipt, taxYear }
        }`,
        variables: {
          criteria: { fiscalYear, taxYear },
        },
        fetchPolicy: 'no-cache',
      });
      clients.handleGQLErrors(results, commit);
      const { taxMaxRecieptNumbers } = results.data;
      return taxMaxRecieptNumbers;
    } catch (e) {
      dispatch('logException', e, { root: true }); clients.handleGQLErrors(results, commit);
      dispatch('flashError', 'There was a problem getting last receipt number', { root: true });
    }
    return {};
  },
  async sendPrintReceiptToEMail({ dispatch, commit }, { item }) {
    let results;
    try {
      const url = `${backendRest.defaults.baseURL}/taxpayment/email-paid-receipt?${urlEncodeObject(item)}`;

      const response = await backendRest.get(url);
      if (response.status === 200) {
        dispatch('flashSuccess', `${response.data.message}`, { root: true });
      } else {
        dispatch('flashError', `${response.data.error}`, { root: true });
      }
    } catch (e) {
      dispatch('logException', e, { root: true }); clients.handleGQLErrors(results, commit);
      dispatch('flashError', 'There was a problem in upserting the Overpayments & Refunds.', { root: true });
    }
    return null;
  },
};

export default taxPaymentTransactionActions;
